module.exports = __webpack_public_path__ + "static/media/home-actualite.1b65acef.jpg";